
const baseUrl = process.env.REACT_APP_BASE_URL;
class Customer {

    constructor(){
        
    }

    createcustomer(countryId, name, address) {



        const token = localStorage.getItem('token');

        const requestData = {
            "name": name,
            "address": address,
            "countryId": countryId
           
        }

        return fetch(baseUrl + '/admin/customer/create', {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        });

    }

    updateCustomer(customerId, name, address) {



        const token = localStorage.getItem('token');

        const requestData = {
            
           
            "customerName": name,
            "customerAddress": address
           
        }

        return fetch(baseUrl + '/admin/customer/update/'+customerId, {
            method: 'PUT',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        });

    }

    customerList(countryId, searchTerm) {



        const token = localStorage.getItem('token');

        const requestData = {
            "searchTerm": searchTerm,
           
            "countryId": countryId
           
        }

        return fetch(baseUrl + '/admin/customer/list', {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        });

    }

    deleteCustomer(customerId) {



        const token = localStorage.getItem('token');


        return fetch(baseUrl + '/admin/customer/delete/'+customerId, {
            method: 'DELETE',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            }
        });

    }
}

export default Customer;